
/** @format */

import React from 'react';
import { Grid, Collapse, CircularProgress, Button } from '@mui/material';
import { useStyles } from '../style';
import { useNavigate } from 'react-router-dom';
import TextItemDotted from '../../../components/TextItemDotted';

const CheckDoc = (props) => {
  const classes = useStyles();
  const { result } = props;
  const navigate = useNavigate();

  return (
    <>
      {result ? (
        <Grid container direction="row" alignItems="center" spacing={0} item xs={12}>

          {/* وضعیت با موفقیت ثبت شده */}
          {result?.source?.warrantyStep !== 'REGISTER_INQUIRY' &&
            result?.source?.warrantyStep !== 'INFO' &&
            result?.source?.warrantyStep !== 'EDIT_INFO' ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader} >
                <h3 className={classes.blockCardTitle}>جزئیات و وضعیت بررسی مدارک</h3>

              </Grid>

              {
                <>
                  <TextItemDotted title=" شماره درخواست " title2={result?.source?.entityId} />
                  <TextItemDotted title="تاریخ درخواست  " isDate={true} title2={result?.persianCreationDate} />
                </>
              }
              <Grid className={classes.blockCardFooter} >
                <h3 className={classes.blockCardFooterTitle}> بررسی مدارک با موفقیت انجام شد.</h3>
              </Grid>
            </Grid>
          ) : (
            ''
          )}

          {/* وضعیت منقضی شده */}
          {(result?.source?.warrantyStep === 'REGISTER_INQUIRY' ||
            result?.source?.warrantyStep === 'INFO' ||
            result?.source?.warrantyStep === 'EDIT_INFO') && result?.source?.warrantyStatus === 'EXPIRED' ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader}>
                <h3 className={classes.blockCardTitle}>جزئیات و وضعیت بررسی مدارک</h3>
              </Grid>
              {
                <>
                  <TextItemDotted title=" شماره درخواست " title2={result?.source?.entityId} />

                </>
              }

              <Grid className={classes.blockCardFooter}>
                <h3 className={classes.blockCardFooterTitle}>
                  درخواست صدور ضمانت نامه منقضی شده است
                </h3>
              </Grid>
            </Grid>
          ) : (
            ''
          )}

          {/* وضعیت  در انتظار */}
          {(result?.source?.warrantyStep === 'REGISTER_INQUIRY' ||
            result?.source?.warrantyStep === 'INFO' ||
            result?.source?.warrantyStep === 'EDIT_INFO') &&
            result?.source?.warrantyStatus === 'WAITING' ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader}>
                <h3 className={classes.blockCardTitle}>جزئیات و وضعیت بررسی مدارک</h3>
              </Grid>

              {
                <>
                  <TextItemDotted title=" شماره درخواست " title2={result?.source?.entityId} />
                </>
              }
              <Grid className={classes.blockCardFooter}>
                <h3 className={classes.blockCardFooterTitle}> اطلاعات شما در حال بررسی می باشد.</h3>
              </Grid>
            </Grid>
          ) : (
            ''
          )}

          {/* وضعیت رد شده */}
          {((result?.source?.warrantyStep === 'REGISTER_INQUIRY' ||
            result?.source?.warrantyStep === 'INFO' ||
            result?.source?.warrantyStep === 'EDIT_INFO') &&
            result?.source?.warrantyStatus === 'REJECTED') ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader}>
                <h3 className={classes.blockCardTitle}>جزئیات و وضعیت بررسی مدارک</h3>
              </Grid>
              {
                <>
                  <TextItemDotted title=" شماره درخواست " title2={result?.source?.entityId} />
                  {result?.source?.inquiryRegister?.complianceDirectivesRegulations?.desc || result?.source?.inquiryRegister?.relatedInquiries?.desc ? (

                    <TextItemDotted
                      title="دلیل رد درخواست "
                      title2=''
                      type="desc"
                    />
                  ) : (
                    ''
                  )}
                  {result?.source?.inquiryRegister?.complianceDirectivesRegulations?.desc || result?.source?.inquiryRegister?.relatedInquiries?.desc ? (
                    <TextItemDotted
                      title=""
                      title2={(result?.source?.inquiryRegister?.complianceDirectivesRegulations?.desc || '') + ' ' + (result?.source?.inquiryRegister?.relatedInquiries?.desc || '')}
                      type="desc"
                    />
                  ) : (
                    ''
                  )}
                </>
              }
              <Grid className={classes.blockCardFooterHasBtn}>
                <h3 className={classes.blockCardFooterTitle}> بررسی مدارک رد شد.</h3>
              </Grid>
            </Grid>
          ) : (
            ''
          )}

          {/* وضعیت تکمیل نشده */}
          {((result?.source?.warrantyStep === 'REGISTER_INQUIRY' ||
            result?.source?.warrantyStep === 'INFO' ||
            result?.source?.warrantyStep === 'EDIT_INFO') &&
            result?.source?.warrantyStatus === 'INCOMPLETE'
          ) ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader}>
                <h3 className={classes.blockCardTitle}>جزئیات و وضعیت بررسی مدارک</h3>
              </Grid>

              {
                <>
                  <TextItemDotted title=" شماره درخواست " title2={result?.source?.entityId} />
                  {result?.source?.inquiryRegister?.complianceDirectivesRegulations?.desc || result?.source?.inquiryRegister?.relatedInquiries?.desc ? (

                    <TextItemDotted
                      title="  دلیل اصلاح درخواست "
                      title2=''
                      type="desc"
                    />
                  ) : (
                    ''
                  )}
                  {result?.source?.inquiryRegister?.complianceDirectivesRegulations?.desc || result?.source?.inquiryRegister?.relatedInquiries?.desc ? (
                    <TextItemDotted
                      title=""
                      title2={(result?.source?.inquiryRegister?.complianceDirectivesRegulations?.desc || '') + ' ' + (result?.source?.inquiryRegister?.relatedInquiries?.desc || '')}
                      type="desc"
                    />

                  ) : (
                    ''
                  )}
                </>
              }
              <Grid className={classes.blockCardFooterHasBtn}>
                <h3 className={classes.blockCardFooterTitle}> بررسی مدارک در وضعیت اصلاح قرار گرفت.</h3>
                <Button
                  color="primary"
                  className={classes.continueBtn}
                  variant="contained"
                  onClick={() => navigate('/Warranty/Request')}
                >
                  ادامه فرایند
                </Button>
              </Grid>
            </Grid>
          ) : (
            ''
          )}

          {/* وضعیت لغو شده  */}
          {(result?.source?.warrantyStep === 'REGISTER_INQUIRY' ||
            result?.source?.warrantyStep === 'INFO' ||
            result?.source?.warrantyStep === 'EDIT_INFO' || result?.source?.warrantyStep === 'INFO') &&
            result?.source?.warrantyStatus === 'CANCELED' ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader}>
                <h3 className={classes.blockCardTitle}>جزئیات و وضعیت بررسی مدارک</h3>
              </Grid>

              {
                <>
                  <TextItemDotted title=" شماره درخواست " title2={result?.source?.entityId} />
                </>
              }
              <Grid className={classes.blockCardFooter}>
                <h3 className={classes.blockCardFooterTitle}>درخواست توسط ضمانت‌خواه لغو شده است.</h3>
              </Grid>
            </Grid>
          ) : (
            ''
          )}
        </Grid>
      ) : (
        result?.length !== 0 ? (
          <div className={classes.loadingFinger}>
            <CircularProgress color="inherit" size={30} />
          </div>
        ) : (
          ''
        )
      )}
    </>
  );
};

export default CheckDoc;
